import React, { FC } from 'react'
import { useScreenClass } from 'react-grid-system'
import styled from 'styled-components'
import { Button, SectionTitle } from '../shared'

const Section = styled.section<{ isDesktop: boolean }>`
  background-color: #002244;
  min-height: ${(props) => (props.isDesktop ? '355px' : 'auto')};
  /* The band used to have no padding at all, so on a phone the heading ran
     right into both screen edges. */
  padding: ${(props) => (props.isDesktop ? '3rem 2rem' : '2.75rem 1.25rem')};
  text-align: center;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  a {
    margin-bottom: 0;
  }
`

const CTA: FC = () => {
  const screenClass = useScreenClass()
  const isDesktop = ['md', 'lg', 'xl'].includes(screenClass)

  return (
    <Section isDesktop={isDesktop}>
      <SectionTitle>
        Ready to amplify your voice?{' '}
        {/* The break is a desktop-only nicety; on a phone the line already
            wraps and a forced break just made the rag worse. */}
        {isDesktop && <br />}
        Join the Podcast Incubator Community.
      </SectionTitle>
      <Button
        external
        variant="red"
        path="https://sbupodcastincubator.substack.com/"
        size="lg"
      >
        Join our Substack
      </Button>
    </Section>
  )
}

export default CTA
